import React from 'react';
import {
    Card,
    FormLayout,
    TextField,
    Checkbox,
    Select,
    Button,
} from '@shopify/polaris';

export function UpdateMultipleProductMetafieldsFromTagGroupSettings(props) {

    const handleTagGroupPrefixChange = (value) => {
        var newSettings = JSON.parse(JSON.stringify(props.settings));
        newSettings.tagGroupPrefix = value;
        props.onSettingsChange(newSettings);
    }

    const handleMetafieldTypeChange = (value) => {
        var newSettings = JSON.parse(JSON.stringify(props.settings));
        newSettings.metafieldType = value;
        props.onSettingsChange(newSettings);
    }

    const onRemoveMetafieldValueWhenTagIsMissingChange = (value) => {
        var newSettings = JSON.parse(JSON.stringify(props.settings));
        newSettings.removeMetafieldValueWhenTagIsMissing = value;
        props.onSettingsChange(newSettings);
    }

    const handleMetafieldNamespaceAndKeyChange = (value, index) => {

        var entries = props.settings.metafieldNamespaceAndKeyEntries;
        entries[index] = value;

        var newSettings = JSON.parse(JSON.stringify(props.settings));
        newSettings.metafieldNamespaceAndKeyEntries = entries;
        props.onSettingsChange(newSettings);
    }

    const onRemoveMetafield = (index) => {

        let newArray = [
            ...props.settings.metafieldNamespaceAndKeyEntries.slice(0, index),
            ...props.settings.metafieldNamespaceAndKeyEntries.slice(index + 1)
        ];

        var newSettings = JSON.parse(JSON.stringify(props.settings));
        newSettings.metafieldNamespaceAndKeyEntries = newArray;
        props.onSettingsChange(newSettings);
    }

    const onAddMetafield = () => {

        const newArray = [
            ...props.settings.metafieldNamespaceAndKeyEntries,
            ""
        ];

        var newSettings = JSON.parse(JSON.stringify(props.settings));
        newSettings.metafieldNamespaceAndKeyEntries = newArray;
        props.onSettingsChange(newSettings);
    }

    var metafieldElemets = props.settings.metafieldNamespaceAndKeyEntries.map((_, index) => {
        return <div><TextField
            label={`Metafield ${index + 1} Namespace and key`}
            placeholder="Namespace and key. For example mystore.custom_size"
            helpText={
                <span>
                    The namespace and key as they appear in your admin.
                </span>
            }
            value={_}
            onChange={(value) => handleMetafieldNamespaceAndKeyChange(value, index)}
            autoComplete="off"
        />
            <Button plain onClick={() => onRemoveMetafield(index)}>Remove metafield from list</Button>
        </div>
    });

    return (
        <React.Fragment>
            <Card.Section>
                <FormLayout>
                    <TextField
                        label="Tag Group prefix"
                        placeholder="Tag Group prefix"
                        helpText={
                            <span>
                                Text that specifies the prefix of the respective tag group. If you would like to work with tags starting with "Style_" for instance, please input that value.
                            </span>
                        }
                        value={props.settings.tagGroupPrefix}
                        error={props.settingsErrors["tagGroupPrefix"]}
                        onChange={handleTagGroupPrefixChange}
                        autoComplete="off"
                    />
                </FormLayout>
            </Card.Section>
            <Card.Section>
                <FormLayout>
                    <Select
                        label="Metafield Type"
                        options={[
                            {
                                'label': 'Single line text',
                                'value': 'single_line_text_field'
                            },
                            {
                                'label': 'Multi line text',
                                'value': 'multi_line_text_field'
                            }
                        ]}
                        onChange={handleMetafieldTypeChange}
                        value={props.settings.metafieldType}
                        helpText={
                            <span>
                                The type of the metafield that will be populated.
                            </span>
                        }
                    />
                    {metafieldElemets}
                    <Button onClick={onAddMetafield}>Add Metafield</Button>
                    <Checkbox
                        label="Remove metafield values when no tag group tag is found"
                        checked={props.settings.removeMetafieldValueWhenTagIsMissing}
                        onChange={onRemoveMetafieldValueWhenTagIsMissingChange}
                        helpText={
                            <span>
                                The rule will remove the metafield values (if set) when no tag belonging to the specified tag group is found.
                            </span>
                        }
                    />
                </FormLayout>
            </Card.Section>
        </React.Fragment>
    );
}